import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const LifestyleCoaching = () => {
  useEffect(() => {
    AOS.init({ duration: 600, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <Heart size={64} className="service-hero-icon" />
            <h1 className="display-large">Lifestyle Coaching</h1>
            <p className="body-large">
              Holistic approach to health and wellness, focusing on sustainable habits that 
              improve your overall quality of life.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img src="https://images.unsplash.com/photo-1608877906479-96f265ab5aab" alt="Healthy Nutrition" />
            </div>
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">Transform Your Lifestyle</h2>
              <p className="body-medium">
                True wellness goes beyond the gym. My lifestyle coaching helps you build 
                sustainable habits around nutrition, sleep, stress management, and overall 
                well-being. It's about creating a balanced life that supports your health goals.
              </p>
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Stress Management</h4>
                      <p className="body-small">Techniques to manage stress and improve mental well-being</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Sleep Optimization</h4>
                      <p className="body-small">Strategies to improve sleep quality and recovery</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Nutrition Education</h4>
                      <p className="body-small">Learn to make informed food choices and meal planning</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Accountability & Support</h4>
                      <p className="body-small">Regular check-ins and motivation to keep you on track</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready for a Lifestyle Change?</h2>
            <p className="body-large">Let's build sustainable habits for long-term health and wellness.</p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
              </Link>
              <Link to="/services"><Button className="btn-secondary">View All Services</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LifestyleCoaching;
